// @ts-nocheck

import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAuth0Login } from 'modules/useAuth0Login'
import { prepareAuth0Redirect } from 'modules/landingUrl'

export const LoginButton = ({ saveAppState, email = undefined, phone = undefined, redirectUri, sms = false, initialUrlParams }: { saveAppState: any, email?: string, phone?: string, redirectUri: string, sms?: boolean, initialUrlParams?: any }) => {
  const { loginWithRedirect, loginWithPopup } = useAuth0Login()
  const options = {
    authorizationParams: {
      screen_hint: "login",
      login_hint: (sms ? phone : email) || undefined,
      redirect_uri: redirectUri,
      connection: sms ? 'sms' : undefined,
    },
  }

  return (
    <Dropdown.Item
      eventKey={'login'}
      onClick={async () => {
        saveAppState()
        prepareAuth0Redirect(initialUrlParams || {})
        if (window.top !== window) {
          window.open(`${location.protocol}//${location.host}/login${sms ? `?login_type=phone&phone=${phone}` : `?email=${email}`}`, '_blank')
          return
        }
        await loginWithRedirect(options)
      }}
    >
      {sms ? 'Login with SMS' : 'Login'}
    </Dropdown.Item>
  )
}
